export default "__VITE_ASSET__BHqaBVBz__"